/**
 * Mock data for Bulk Access Management feature
 *
 * This mock structure represents a course with modules, lessons, materials, and homeworks.
 * It's used during development to test the UI without making real API calls.
 */

// Define which materials currently have access (approximately 50%)
const currentAccess = [
  101, 102, 104, 106, 108, 109, 111, 113, 115, 117, 119, 121, 123, 125, 127, 129,
  201, 203, 205, 207, 209, 211
]

export const mockCourseStructure = {
  courseId: 47,
  packageId: 119,
  packageName: "Преміум пакет",
  currentAccess: currentAccess,
  modules: [
    {
      id: 68,
      name: "Модуль 1: Основи бухгалтерського обліку",
      lessons: [
        {
          id: 150,
          name: "Урок 1: Вступ до бухобліку",
          materials: [
            {
              id: 101,
              name: "Вступне відео",
              type: "video",
              order: 1,
              hasAccess: currentAccess.includes(101)
            },
            {
              id: 102,
              name: "Конспект уроку",
              type: "text",
              order: 2,
              hasAccess: currentAccess.includes(102)
            },
            {
              id: 103,
              name: "Презентація",
              type: "pdf",
              order: 3,
              hasAccess: currentAccess.includes(103)
            },
            {
              id: 104,
              name: "Додаткові матеріали",
              type: "file",
              order: 4,
              hasAccess: currentAccess.includes(104)
            }
          ],
          homeworks: [
            {
              id: 201,
              name: "Домашнє завдання 1: Основні поняття",
              order: 1,
              hasAccess: currentAccess.includes(201)
            }
          ]
        },
        {
          id: 151,
          name: "Урок 2: Первинні документи",
          materials: [
            {
              id: 105,
              name: "Відео: Види документів",
              type: "video",
              order: 1,
              hasAccess: currentAccess.includes(105)
            },
            {
              id: 106,
              name: "Зразки документів",
              type: "pdf",
              order: 2,
              hasAccess: currentAccess.includes(106)
            },
            {
              id: 107,
              name: "Аудіо-коментар експерта",
              type: "audio",
              order: 3,
              hasAccess: currentAccess.includes(107)
            },
            {
              id: 108,
              name: "Методичні рекомендації",
              type: "text",
              order: 4,
              hasAccess: currentAccess.includes(108)
            }
          ],
          homeworks: [
            {
              id: 202,
              name: "Домашнє завдання 2: Робота з документами",
              order: 1,
              hasAccess: currentAccess.includes(202)
            },
            {
              id: 203,
              name: "Практична вправа: Заповнення документів",
              order: 2,
              hasAccess: currentAccess.includes(203)
            }
          ]
        },
        {
          id: 152,
          name: "Урок 3: Рахунки обліку",
          materials: [
            {
              id: 109,
              name: "План рахунків",
              type: "pdf",
              order: 1,
              hasAccess: currentAccess.includes(109)
            },
            {
              id: 110,
              name: "Відео-пояснення",
              type: "video",
              order: 2,
              hasAccess: currentAccess.includes(110)
            },
            {
              id: 111,
              name: "Приклади проводок",
              type: "text",
              order: 3,
              hasAccess: currentAccess.includes(111)
            }
          ],
          homeworks: [
            {
              id: 204,
              name: "Домашнє завдання 3: Складання проводок",
              order: 1,
              hasAccess: currentAccess.includes(204)
            }
          ]
        }
      ]
    },
    {
      id: 69,
      name: "Модуль 2: Облік для ФОП",
      lessons: [
        {
          id: 153,
          name: "Урок 1: Особливості обліку ФОП",
          materials: [
            {
              id: 112,
              name: "Вступне відео для ФОП",
              type: "video",
              order: 1,
              hasAccess: currentAccess.includes(112)
            },
            {
              id: 113,
              name: "Законодавча база",
              type: "pdf",
              order: 2,
              hasAccess: currentAccess.includes(113)
            },
            {
              id: 114,
              name: "Інфографіка: Системи оподаткування",
              type: "image",
              order: 3,
              hasAccess: currentAccess.includes(114)
            },
            {
              id: 115,
              name: "Текстові матеріали",
              type: "text",
              order: 4,
              hasAccess: currentAccess.includes(115)
            },
            {
              id: 116,
              name: "Калькулятор податків",
              type: "file",
              order: 5,
              hasAccess: currentAccess.includes(116)
            }
          ],
          homeworks: [
            {
              id: 205,
              name: "Домашнє завдання 1: Вибір системи оподаткування",
              order: 1,
              hasAccess: currentAccess.includes(205)
            }
          ]
        },
        {
          id: 154,
          name: "Урок 2: Книга обліку доходів",
          materials: [
            {
              id: 117,
              name: "Відео: Як вести книгу обліку",
              type: "video",
              order: 1,
              hasAccess: currentAccess.includes(117)
            },
            {
              id: 118,
              name: "Зразок книги обліку",
              type: "pdf",
              order: 2,
              hasAccess: currentAccess.includes(118)
            },
            {
              id: 119,
              name: "Інструкція з заповнення",
              type: "text",
              order: 3,
              hasAccess: currentAccess.includes(119)
            }
          ],
          homeworks: [
            {
              id: 206,
              name: "Домашнє завдання 2: Заповнення книги обліку",
              order: 1,
              hasAccess: currentAccess.includes(206)
            },
            {
              id: 207,
              name: "Практичне завдання: Кейс ФОП",
              order: 2,
              hasAccess: currentAccess.includes(207)
            }
          ]
        }
      ]
    },
    {
      id: 70,
      name: "Модуль 3: Податкова звітність",
      lessons: [
        {
          id: 155,
          name: "Урок 1: Види звітності",
          materials: [
            {
              id: 120,
              name: "Огляд звітності",
              type: "video",
              order: 1,
              hasAccess: currentAccess.includes(120)
            },
            {
              id: 121,
              name: "Календар звітності",
              type: "pdf",
              order: 2,
              hasAccess: currentAccess.includes(121)
            },
            {
              id: 122,
              name: "Схема подання звітів",
              type: "image",
              order: 3,
              hasAccess: currentAccess.includes(122)
            },
            {
              id: 123,
              name: "Методичка з звітності",
              type: "text",
              order: 4,
              hasAccess: currentAccess.includes(123)
            }
          ],
          homeworks: [
            {
              id: 208,
              name: "Домашнє завдання 1: Складання календаря",
              order: 1,
              hasAccess: currentAccess.includes(208)
            }
          ]
        },
        {
          id: 156,
          name: "Урок 2: Єдиний податок",
          materials: [
            {
              id: 124,
              name: "Відео: Заповнення декларації",
              type: "video",
              order: 1,
              hasAccess: currentAccess.includes(124)
            },
            {
              id: 125,
              name: "Бланк декларації",
              type: "pdf",
              order: 2,
              hasAccess: currentAccess.includes(125)
            },
            {
              id: 126,
              name: "Аудіо-консультація",
              type: "audio",
              order: 3,
              hasAccess: currentAccess.includes(126)
            },
            {
              id: 127,
              name: "Приклади заповнення",
              type: "text",
              order: 4,
              hasAccess: currentAccess.includes(127)
            }
          ],
          homeworks: [
            {
              id: 209,
              name: "Домашнє завдання 2: Декларація єдиного податку",
              order: 1,
              hasAccess: currentAccess.includes(209)
            }
          ]
        },
        {
          id: 157,
          name: "Урок 3: ПДВ декларація",
          materials: [
            {
              id: 128,
              name: "Вебінар: ПДВ для початківців",
              type: "video",
              order: 1,
              hasAccess: currentAccess.includes(128)
            },
            {
              id: 129,
              name: "Форми декларації ПДВ",
              type: "pdf",
              order: 2,
              hasAccess: currentAccess.includes(129)
            },
            {
              id: 130,
              name: "Покрокова інструкція",
              type: "text",
              order: 3,
              hasAccess: currentAccess.includes(130)
            },
            {
              id: 131,
              name: "Ілюстрації заповнення",
              type: "image",
              order: 4,
              hasAccess: currentAccess.includes(131)
            }
          ],
          homeworks: [
            {
              id: 210,
              name: "Домашнє завдання 3: Практика з ПДВ",
              order: 1,
              hasAccess: currentAccess.includes(210)
            },
            {
              id: 211,
              name: "Фінальна робота: Комплексна декларація",
              order: 2,
              hasAccess: currentAccess.includes(211)
            }
          ]
        }
      ]
    }
  ]
}

// Export for testing/validation
export const getMockStatistics = () => {
  let totalMaterials = 0
  let totalHomeworks = 0
  let modulesCount = mockCourseStructure.modules.length
  let lessonsCount = 0

  mockCourseStructure.modules.forEach(module => {
    lessonsCount += module.lessons.length
    module.lessons.forEach(lesson => {
      totalMaterials += lesson.materials.length
      totalHomeworks += lesson.homeworks.length
    })
  })

  return {
    modules: modulesCount,
    lessons: lessonsCount,
    materials: totalMaterials,
    homeworks: totalHomeworks,
    totalItems: totalMaterials + totalHomeworks,
    withAccess: mockCourseStructure.currentAccess.length,
    accessPercentage: Math.round((mockCourseStructure.currentAccess.length / (totalMaterials + totalHomeworks)) * 100)
  }
}

// Validation check
if (typeof window !== 'undefined' && window.console) {
  const stats = getMockStatistics()
  console.log('📊 Mock Course Structure Statistics:', stats)
}
